import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ImportScriptHome,
  CreateRoboSpaik,
  humanAttendent,
  useOurTemplate,
  OmnichannelSpaik,
  spaikIcon
} from "../../../assets";
import { Text } from "../../../components/Text";
import DialogCreateFromZero from "../../../components/template/addBlocks/DialogCreateFromZero";
import { useAppSelector } from "../../../redux/hooks";
import { CardHome } from "./Components/CardHome";
import {
  BgGradient,
  Container,
  ContainerImage,
  ContainerTransparent,
  DivImage,
  Img
} from "./styles";
import { useAuth, AuthContextType } from "../../../auth/auth-provider";
import { useToast } from "../../../components/toast-provider";

export const HomePage: React.FC = () => {
  const bots = useAppSelector((state) => state.chatbots.chatbots);
  const [openDialogCreateFromZero, setOpenDialogCreateFromZero] =
    useState(false);
  const redirect = useNavigate();
  const toast = useToast();
  const handleOmniChannel = () => {
    redirect("/omnichannel");
  };
  const handleOpenDialogCreateFromZero = () => {
    if (hasAnyPermission("bot_create")) {
      setOpenDialogCreateFromZero(true);
    } else {
      toast.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: "Seu usuário não tem permissão para incluir um novo bot!"
      });
    }
  };
  const { user, hasAnyPermission } = useAuth() as AuthContextType;

  return (
    <Container>
      <BgGradient
        style={{
          background: user.plataform.mainColor
            ? user.plataform.mainColor
            : "#2624CD"
        }}
      />
      <ContainerTransparent>
        <div className="flex gap-3">
          <ContainerImage>
            <DivImage>
              {user.plataform.urlAvatar ? (
                <Img
                  src={user.plataform.urlAvatar}
                  style={{
                    maxHeight: "350px",
                    width: "65px",
                    height: "75px"
                  }}
                />
              ) : (
                <Img
                  src={spaikIcon}
                  alt="Bot Spaik"
                  style={{
                    maxHeight: "400px",
                    width: "65px",
                    height: "75px"
                  }}
                />
              )}
            </DivImage>
          </ContainerImage>
          <div className="flex flex-column align-itens-start justify-content-between h-4rem">
            <Text color="#FFF" weight={600} s="1.25rem" lh="1.75rem">
              Atendimento inteligente e automatizado
            </Text>
            <Text
              color="#FFF"
              weight={400}
              s="0.875rem"
              lh="1.25rem"
              style={{ textAlign: "left" }}
            >
              {`${bots?.length || 0} Bot${bots?.length > 1 ? "s" : ""}`} | 2
              canais conectados | Ver Insights
            </Text>
          </div>
        </div>
        <div className="flex align-itens-start w-full justify-content-between">
          <div className="flex mt-4 w-full align-items-center justify-content-between gap-2 flex-wrap">
            <>
              <CardHome
                onClick={handleOpenDialogCreateFromZero}
                title="Criar Bot do zero"
                subtitle={`Utilize a área do ${user.plataform.displayName} para criar um chatbot de forma prática e personalizada.`}
              >
                <img width="70%" src={CreateRoboSpaik} alt="Create Robot" />
              </CardHome>
              <CardHome
                onClick={handleOmniChannel}
                title="Omnichannel"
                subtitle="Realize atendimentos em um ambiente totalmente integrado."
              >
                <img width="70%" src={OmnichannelSpaik} alt="Create Robot" />
              </CardHome>
            </>

            <CardHome
              proximoLancamento={true}
              title="Usar nossos templates"
              subtitle="Escolha um template pronto e facilite toda implementação do seu robô."
            >
              <img width="70%" src={humanAttendent} alt="Create Robot" />
            </CardHome>
            <CardHome
              proximoLancamento={true}
              title="Importar Script"
              subtitle="Importe Scripts de Conversação de forma fácil e prática."
            >
              <img width="100%" src={ImportScriptHome} alt="Create Robot" />
            </CardHome>
          </div>
        </div>
      </ContainerTransparent>
      <DialogCreateFromZero
        displayDialog={openDialogCreateFromZero}
        onHide={() => setOpenDialogCreateFromZero(false)}
      />
    </Container>
  );
};
